import React from 'react';
import { Container } from 'reactstrap';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import ResetPasswordContainer from '../containers/ResetPasswordContainer';

const ResetPassword = () => (
  <HeaderContainerTemplate>
    <Container>
      <ResetPasswordContainer />
    </Container>
  </HeaderContainerTemplate>
);

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/scenes/ResetPassword.js